import React, { useState, useEffect } from "react";
import "./Loading.scss";
import { motion } from "framer-motion";

const Loading = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 5 ? prev + "." : ""));
    }, 500);

    return () => clearInterval(interval);
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="loading-event"
    >
      <div className="loading-event-wrapper">
        <svg
          className="atom-loading"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="3 3 94 94"
        >
          <g stroke="black">
            <circle strokeWidth="0" cx="50" cy="50" r="9" fill="#9eecff" />{" "}
            <path
              strokeWidth="2.5"
              stroke="#cbd5e1"
              d="M50 10 A 15 40 0 1 1 49.99 10 Z"
              fill="none"
            />
            <path
              strokeWidth="2.5"
              stroke="#cbd5e1"
              d="M50 10 A 15 40 0 1 1 49.99 10 Z"
              fill="none"
              transform="rotate(60, 50, 50)"
            />
            <path
              strokeWidth="2.5"
              stroke="#cbd5e1"
              d="M50 10 A 15 40 0 1 1 49.99 10 Z"
              fill="none"
              transform="rotate(120, 50, 50)"
            />
            <circle strokeWidth="0" r="4" fill="#c3c2ff">
              <animateMotion
                offset="25%"
                dur="2"
                keyPoints="0;0.04774575140626314;0.17274575140626314;0.32725424859373686;0.45225424859373686;0.5;0.5477457514062631;0.6727457514062631;0.8272542485937369;0.9522542485937369;1"
                keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                calcMode="linear"
                keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                repeatCount="indefinite"
                path="M50 10 A 15 40 0 1 1 49.99 10 Z"
              />
              <animateTransform
                dur="2"
                attributeName="transform"
                type="scale"
                values="1;1.1175570504584946;1.1902113032590307;1.1902113032590307;1.1175570504584946;1;0.8824429495415054;0.8097886967409693;0.8097886967409693;0.8824429495415054;1"
                keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                calcMode="linear"
                keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                repeatCount="indefinite"
              />
            </circle>
            <g transform="rotate(60, 50, 50)">
              <circle strokeWidth="0" r="4" fill="#c3c2ff">
                <animateMotion
                  offset="25%"
                  dur="1.5"
                  keyPoints="0;0.04774575140626314;0.17274575140626314;0.32725424859373686;0.45225424859373686;0.5;0.5477457514062631;0.6727457514062631;0.8272542485937369;0.9522542485937369;1"
                  keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                  calcMode="linear"
                  keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                  repeatCount="indefinite"
                  path="M50 10 A 15 40 0 1 1 49.99 10 Z"
                />
                <animateTransform
                  dur="1.5"
                  attributeName="transform"
                  type="scale"
                  values="1;1.1175570504584946;1.1902113032590307;1.1902113032590307;1.1175570504584946;1;0.8824429495415054;0.8097886967409693;0.8097886967409693;0.8824429495415054;1"
                  keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                  calcMode="linear"
                  keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
            <g transform="rotate(120, 50, 50)">
              <circle strokeWidth="0" r="4" fill="#c3c2ff">
                <animateMotion
                  offset="25%"
                  dur="1.2"
                  keyPoints="0;0.04774575140626314;0.17274575140626314;0.32725424859373686;0.45225424859373686;0.5;0.5477457514062631;0.6727457514062631;0.8272542485937369;0.9522542485937369;1"
                  keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                  calcMode="linear"
                  keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                  repeatCount="indefinite"
                  path="M50 10 A 15 40 0 1 1 49.99 10 Z"
                />
                <animateTransform
                  dur="1.2"
                  attributeName="transform"
                  type="scale"
                  values="1;1.1175570504584946;1.1902113032590307;1.1902113032590307;1.1175570504584946;1;0.8824429495415054;0.8097886967409693;0.8097886967409693;0.8824429495415054;1"
                  keyTimes="0;.1;.2;.3;.4;.5;.6;0.7;0.8;0.9;1"
                  calcMode="linear"
                  keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </g>
        </svg>
        <h1>Tunggu Sebentar{dots}</h1>
      </div>
    </motion.div>
  );
};

export default Loading;
